import React from "react";
import { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
function MapManagement() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };
  const pageName = "Map Management";
  return (
    <>
      <div className="grid-container">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />
      </div>
    </>
  );
}

export default MapManagement;
